import Web3 from 'web3'
import {contractAddress, ABI} from './constants/counterContract'

let getContract = new Promise(function (resolve, reject) {
  let web3 = new Web3(window.web3.currentProvider)
  let counterContractInstance = new web3.eth.Contract(ABI)
  counterContractInstance.options.address = contractAddress
  // need to use infura websocket which isn't supported by metamask yet
  let infuraInstance = new Web3(new Web3.providers.WebsocketProvider('wss://ropsten.infura.io/ws'))
  let iCI = new infuraInstance.eth.Contract(ABI)
  iCI.options.address = contractAddress
  iCI.events.incrCounterEvent().on('data', (event) => {
    console.log('we caught the incrCounterEvent', event)
  }).on('error', console.error)

  // casinoContractInstance = () => casinoContractInstance
  resolve(counterContractInstance)
})
export default getContract



// WEBPACK FOOTER //
// ./src/util/getContract.js